import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';

import { trackOffersReliableLabelClick } from './tracking';
import { ReliableBlock } from '../../components/ReliableBlock';
import { isReliableHouseSelector } from '../../selectors/newbuilding';
import { getSelectedHouseId } from '../../selectors/offers';

export function ReliableBlockContainer() {
  const isReliable = useSelector(isReliableHouseSelector);
  const houseId = useSelector(getSelectedHouseId);
  const reliableText = houseId ? 'Надежность корпуса проверена' : 'Есть корпуса, проверенные на надежность';

  const onReliableLabelClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#reliable',
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackOffersReliableLabelClick();
  };

  return isReliable ? <ReliableBlock text={reliableText} onClick={onReliableLabelClick} /> : null;
}
